export default __webpack_public_path__ + "static/media/newVideo.mp4";